export default {
  namespaced: true,
  state: {
    list: [],
  },
  getters: {
    list: state => state.list,
  },
  mutations: {
    listMutate(state, data) {
      state.list = data;
    },
   
  },
  actions: {

    setList(context, data) {
      context.commit('listMutate', data);
    },


  },
};
